import React, { Component } from "react"
import PropTypes from "prop-types"
import { withRouter } from "react-router-dom"
import { connect } from "react-redux"
import MetaTags from 'react-meta-tags';
import { withTranslation } from "react-i18next"
import Breadcrumbs from "../../../components/Common/Breadcrumb"
import "react-super-responsive-table/dist/SuperResponsiveTableStyle.css"
import { Link } from "react-router-dom"
import { Formik, Field, Form, ErrorMessage } from "formik";
import * as Yup from "yup";
import { isEmpty, map } from "lodash"
import { getProjectUUIDAction, addProjectSettingWorksheet, getProjectSettingWorksheet, deleteProjectSettingWorksheet, updateProjectWorksheetUnit } from "../../../store/projects/actions"
import FileBase64 from "../../../components/Common/FileBase64";
import Moment from 'react-moment';
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { CKEditor } from '@ckeditor/ckeditor5-react';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import DeleteModal from "../../../components/Common/DeleteModal";
import ProjectSidebar from "../../../components/VerticalLayout/ProjectSidebar";
import img1 from "../../../assets/img/doc-1.png"
import img2 from "../../../assets/img/doc-2.png"
import img3 from "../../../assets/img/email.png"
import img4 from "../../../assets/img/sales.png"
import img5 from "../../../assets/img/doc-3.png"
import step1 from "../../../assets/img/step-1.png"
import step2 from "../../../assets/img/step-2.png"
import step3 from "../../../assets/img/step-3.png"
import noIcon from "../../../assets/img/no-icon.png"
import {
  Row,
  Col,
  CardBody,
  Card,
  CardText,
  Container,
  Nav,
  NavItem,
  NavLink,
  TabContent,
  TabPane,
  FormGroup,
  Label,
  Tooltip,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  UncontrolledDropdown,
  Button,
  CardTitle,
  CardHeader,
} from "reactstrap"
import WebpagesMenu from "./menu/webpages-menu";
import WebPageBreadcrumbs from "components/Common/WebpageBreadcrumb";
import CopyText from "components/buttons/copyBtn";
import SaveButton from "components/buttons/save";
import SafeField from "helpers/SafeField";

class projectWorksheet extends Component {
  constructor(props) {
    super(props)
    this.state = {
      activeTab: "1",
      verticalActiveTab: "1",
      page: 1,
      sizePerPage: 10,
      //prospectsData: prospectsData,
      visible: false,
      status: 1,
      files: [],
      reports: [
        { title: "Email Sent", iconClass: "bx-copy-alt", description: "14" },
        {
          title: "# Prospects",
          iconClass: "bx-archive-in",
          description: "6",
        },
        {
          title: "# SRR",
          iconClass: "bx-purchase-tag-alt",
          description: "5",
        },
        {
          title: "# Clients",
          iconClass: "bx-purchase-tag-alt",
          description: "2",
        },
      ]

    }

    this.handleProjectWorksheetSubmit = this.handleProjectWorksheetSubmit.bind(this)
    this.onClickDelete = this.onClickDelete.bind(this);
  }
  onClickDelete = (worksheet) => {
    this.setState({ worksheet: worksheet });
    this.setState({ deleteModal: true });
  };

  handleDeleteWorksheet = () => {
    const { onDeleteWorksheet } = this.props;
    const { worksheet } = this.state;
    if (worksheet.id !== undefined) {

      onDeleteWorksheet(worksheet);
      this.setState({ deleteModal: false });
    }
  };
  radioHandler = (status) => {
    this.setState({ status });
  };
  getFiles(files) {
    this.setState({ files: files })
    //

  }
  componentDidMount() {

    const { match: { params }, ongetProjectUUIDAction, onGetProjectSettingWorksheet } = this.props;

    if (params && params.projectId) {
      ongetProjectUUIDAction(params.projectId);
      onGetProjectSettingWorksheet(params.projectId)
    }
  }
  handleProjectWorksheetSubmit(value) {
    this.props.addProjectSettingWorksheet(value, this.props.history)
  }
  render() {
    const { status, deleteModal } = this.state;
    const { projectData, worksheets, onUpdateProjectWorksheetUnit, isResponsive} = this.props;

    return (
      <React.Fragment>
        {this.props.loading && this.props.loading ? (
          <div className="loading">Loading&#8230;</div>
        ) : null}
        <DeleteModal
          show={deleteModal}
          onDeleteClick={this.handleDeleteWorksheet}
          onCloseClick={() => this.setState({ deleteModal: false })}
        />
        <ToastContainer autoClose={2000} />
        <div className="page-content project-page-content">

          <MetaTags>
            <title>Campaigns | Realty Space</title>
          </MetaTags>
          <Container fluid className="ps-0 ">
                <Row>
                    <Col sm='2' className="pe-0" >
                    <ProjectSidebar isResponsive={isResponsive} />
                     </Col>
                <Col sm='10' className="ps-0">
                <Row className="project-header">
                   <Col sm="7">
                <WebPageBreadcrumbs title={this.props.t("Projects")} breadcrumbItem={this.props.t("Worksheets Page")} />
                </Col>
                <Col sm="4">
                <h2 className="">{this.props.t( projectData.projectName)}</h2>
                </Col>
                </Row>
            <Row>
            <WebpagesMenu isResponsive={isResponsive} />
              <Col lg="12">
                <Card className="height-100">
                  <CardBody>
                    <TabContent
                      activeTab={this.state.activeTab}
                      className="p-3 text-muted"
                    >
                      <Row>
                        <Col sm="12">
                        <div className="link-page">
                          <h5>
                            <span><a target="_blank" rel="noreferrer" href={"https://worksheets.realtyspacehub.com/preview/" + this.props.match.params.projectId}><i className="bx bx-link-external"></i> Preview only</a></span> <img src={noIcon} width="40" className="me-2" /> <strong>Note: Do not copy or share the preview  URL. </strong>
                            </h5>
                      </div>
                        </Col>
                      </Row>
                        {/* <Row className="align-items-stretch"> 
                          <Col sm="5">
                              <Card className="border-brk mt-40">
                                <CardHeader>
                                <CardTitle>Create your Worksheet </CardTitle>
                                <p>Use the worksheet link to collect client interest digitally. Once submitted, their unit choices will be recorded directly into the system.</p>
                                </CardHeader>
                                <CardBody>
                              
                                </CardBody>
                              </Card>
                          </Col>
                          <Col sm="1" className="d-flex align-items-stretch justify-content-center">
                          <div className="vertical-line"></div>
                          </Col>
                          <Col sm="6">
                          <div className="link-page mt-40">
                     
                      <div className="open-bg">
                      <h4><img src={img5} width="32px" /> Purpose </h4>
                      <ul className="no-list-type">
                            <li> Simplify and accelerate the worksheet intake process so you can easily collect, organize, and act on client submissions — all in one place. </li>
                  
                        </ul>
                        <h4><img src={img1} width="32px" /> How To Use </h4>
                        <ul className="no-list-type">
                            <li><strong>Preview and Set Up Your Worksheet Page </strong> <br />Each project has an auto-generated Worksheet Submission page. You can preview it from this screen. Before sharing the link, make sure to select the number of unit choices a buyer can submit  </li>
                            <li><strong>Send Worksheet to Project Leads </strong><br/> Worksheets are linked to individual leads, so they <strong>cannot be used in general mass email campaigns.</strong> You can send the worksheet through the <strong>Sales Activity</strong> section by selecting specific leads within the project and clicking Send Worksheet. </li>
                        </ul>
                        <h4><img src={img2} width="32px" /> Benefits</h4>
                        <ul>
                            <li>Digital worksheet collection tied to specific leads </li>
                            <li>Email alerts and centralized CRM tracking</li>
                            <li>Fully trackable and secure submission process </li>
                             <li>Option to print worksheets for builder use or personal records </li>
                      
                        </ul>
                        
                      </div>
                  
                        </div>
                          </Col>
                        </Row> */}
                           

                        <Row>
                          <Col sm="4" className="d-flex">
                            <Card className="border-full mt-4 w-100">
                                <CardHeader><h5 className="font-size-18" style={{fontWeight:'bold'}}><img src={step1}  width="40" className="me-2" /> Purpose</h5></CardHeader>
                                <CardBody className="d-flex flex-column">
                                    <p className="text-dark font-size-16">Simplify the process by collecting worksheets online — fast and organized..</p>
                                </CardBody>
                            </Card>
                          </Col>
                           <Col sm="4" className="d-flex">
                            <Card className="border-full mt-4 w-100">
                                <CardHeader><h5 className="font-size-18" style={{fontWeight:'bold'}}><img src={step2}  width="40" className="me-2" /> Setup project worksheet</h5></CardHeader>
                                <CardBody className="d-flex flex-column">
                                      <ol className="text-dark font-size-16">
                                          <li>Set the number of unit options that the client has to fill.</li>
                                          <li>Click <strong>Save</strong></li>
                                      </ol>
                                </CardBody>
                            </Card>
                          </Col>

                          <Col sm="4" className="d-flex">
                            <Card className="border-full mt-4 w-100">
                                <CardHeader><h5 className="font-size-18" style={{fontWeight:'bold'}}><img src={step2}  width="40" className="me-2" /> How To Use</h5></CardHeader>
                                <CardBody className="d-flex flex-column">
                                      <p className="text-dark font-size-16">To send a worksheet, </p>
                                      <ol className="text-dark font-size-16">
                                          <li>go to the Sales Activity tab, select lead(s).</li>
                                          <li>Use the ‘Send Worksheet’ option. </li>
                                      </ol>

                                      
                              
                                </CardBody>
                            </Card>
                          </Col>
                        </Row>

                        <Row className="mt-4">
                          <Col sm="5">
                            <h3 style={{fontSize:20}} className="text-dark"><strong>Setup your worksheet</strong></h3>
                        <div className="clearfix"></div>
                              <Formik
              enableReinitialize={true}
              initialValues={{
                agentId: localStorage.getItem('userId'),
                id:projectData.id,
                NoOfUnitforWorkSheet: projectData.noOfUnitforWorkSheet,

              }}
              validationSchema={Yup.object().shape({
                NoOfUnitforWorkSheet: Yup.string().required("This is Required")
              })}

              onSubmit={values => {
                  const data = {
                    agentId: parseInt(values.agentId),
                    id:values.id,
                    NoOfUnitforWorkSheet: parseInt(values.NoOfUnitforWorkSheet)
                  };
                  onUpdateProjectWorksheetUnit(data);
              }}
            >
              {({ errors, touched, values, handleChange, setFieldValue }) => (
                <Form
                  className="needs-validation"
                >

            
                  <Row>
                    <Col md="8">
                      <FormGroup className="mb-3">
                        <Label htmlFor="NoOfUnitforWorkSheet">
                          {this.props.t("Select # of unit choices available for the user to fill")}
                        </Label>
                       
                      </FormGroup>
                    </Col>
                    <Col md="3">
                    <SafeField as="select" className="form-control" name="NoOfUnitforWorkSheet">
                  
                        <option value="2">2</option>
                        <option value="3">3</option>
                        <option value="4">4</option>
                        <option value="5">5</option>
                    </SafeField>
                        <ErrorMessage
                          name="addNote"
                          component="div"
                          className="invalid-feedback"
                        />
                    </Col>
                    
                  </Row>
              
                  <div className="clearfix">
                    
                    <SaveButton className="btn btn-save btn-lg">Save</SaveButton>
                   </div>


                </Form>
              )}
            </Formik>
                          </Col>
                        </Row>
                    </TabContent>
                  </CardBody>
                </Card>


              </Col>
            </Row>


            <Row>

            </Row>
            </Col>
            </Row>
          </Container>
        </div>
      </React.Fragment>
    )
  }
}

projectWorksheet.propTypes = {
  t: PropTypes.any,
  history: PropTypes.func,
  match: PropTypes.object,
  ongetProjectUUIDAction: PropTypes.func,
  projectData: PropTypes.object,
  addProjectSettingWorksheet: PropTypes.func,
  onGetProjectSettingWorksheet: PropTypes.func,
  worksheets: PropTypes.array,
  loading: PropTypes.object,
  onDeleteWorksheet: PropTypes.func,
  onUpdateProjectWorksheetUnit:PropTypes.func,
  isResponsive:PropTypes.object
}
const mapStateToProps = ({ Project }) => (
  {
    projectData: Project.projectData,
    worksheets: Project.worksheets,
    loading: Project.loading

  })
const mapDispatchToProps = dispatch => ({
  ongetProjectUUIDAction: (id) => dispatch(getProjectUUIDAction(id)),
  addProjectSettingWorksheet: (data) => dispatch(addProjectSettingWorksheet(data)),
  onDeleteWorksheet: (id) => dispatch(deleteProjectSettingWorksheet(id)),
  onGetProjectSettingWorksheet: (projectId) => dispatch(getProjectSettingWorksheet(projectId)),
  onUpdateProjectWorksheetUnit:(data) => dispatch(updateProjectWorksheetUnit(data))
});
export default connect(mapStateToProps, mapDispatchToProps)(withRouter(withTranslation()(projectWorksheet)))
